import { GetQboAccounts } from '../../domain/usecases/get-qbo-accounts';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetQboAccounts extends BaseHttpService<GetQboAccounts.Model> implements GetQboAccounts {
  async getAllByLocationId(params: GetQboAccounts.Params): Promise<GetQboAccounts.Model> {
    return await this.request('get', {}, params);
  }
}
